// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__MMvL_","title":"style_title__ATbSt","links":"style_links__7zy6q","link":"style_link__SMtdx"};